import type { PaletteAnchorRef } from './types';

const paletteRefIdMap = new WeakMap<PaletteAnchorRef, string>();

/**
 * Get a unique identifier for a palette anchor.
 */
export function getPaletteId(anchorRef: PaletteAnchorRef): string {
    let id = paletteRefIdMap.get(anchorRef);
    if (!id) {
        id = Math.random().toString(36).substring(2);
        paletteRefIdMap.set(anchorRef, id);
    }
    return id;
}
